import { render } from "./video.vue?vue&type=template&id=cb397a02&scoped=true"
import script from "./video.vue?vue&type=script&lang=js"
export * from "./video.vue?vue&type=script&lang=js"

import "./video.vue?vue&type=style&index=0&id=cb397a02&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb397a02"]])

export default __exports__